/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { MedicalSystemBeamLimitingDeviceType } from './MedicalSystemBeamLimitingDeviceType';
import {
    MedicalSystemBeamLimitingDeviceTypeFromJSON,
    MedicalSystemBeamLimitingDeviceTypeFromJSONTyped,
    MedicalSystemBeamLimitingDeviceTypeToJSON,
} from './MedicalSystemBeamLimitingDeviceType';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { CoordinateSystem } from './CoordinateSystem';
import {
    CoordinateSystemFromJSON,
    CoordinateSystemFromJSONTyped,
    CoordinateSystemToJSON,
} from './CoordinateSystem';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { OneOfPropertyOfPtw100InternalArea } from './OneOfPropertyOfPtw100InternalArea';
import {
    OneOfPropertyOfPtw100InternalAreaFromJSON,
    OneOfPropertyOfPtw100InternalAreaFromJSONTyped,
    OneOfPropertyOfPtw100InternalAreaToJSON,
} from './OneOfPropertyOfPtw100InternalArea';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { ElectronBeamQualitiesDto } from './ElectronBeamQualitiesDto';
import {
    ElectronBeamQualitiesDtoFromJSON,
    ElectronBeamQualitiesDtoFromJSONTyped,
    ElectronBeamQualitiesDtoToJSON,
} from './ElectronBeamQualitiesDto';
import type { MedicalSystemBeamProduction } from './MedicalSystemBeamProduction';
import {
    MedicalSystemBeamProductionFromJSON,
    MedicalSystemBeamProductionFromJSONTyped,
    MedicalSystemBeamProductionToJSON,
} from './MedicalSystemBeamProduction';
import type { PhotonBeamQualitiesDto } from './PhotonBeamQualitiesDto';
import {
    PhotonBeamQualitiesDtoFromJSON,
    PhotonBeamQualitiesDtoFromJSONTyped,
    PhotonBeamQualitiesDtoToJSON,
} from './PhotonBeamQualitiesDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { NullableOneOfPropertyOfStorageLocation } from './NullableOneOfPropertyOfStorageLocation';
import {
    NullableOneOfPropertyOfStorageLocationFromJSON,
    NullableOneOfPropertyOfStorageLocationFromJSONTyped,
    NullableOneOfPropertyOfStorageLocationToJSON,
} from './NullableOneOfPropertyOfStorageLocation';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';

/**
 * 
 * @export
 * @interface LinearAcceleratorDto
 */
export interface LinearAcceleratorDto {
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof LinearAcceleratorDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LinearAcceleratorDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LinearAcceleratorDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LinearAcceleratorDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LinearAcceleratorDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof LinearAcceleratorDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof LinearAcceleratorDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof LinearAcceleratorDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof LinearAcceleratorDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof LinearAcceleratorDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof LinearAcceleratorDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof LinearAcceleratorDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof LinearAcceleratorDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof LinearAcceleratorDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {number}
     * @memberof LinearAcceleratorDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LinearAcceleratorDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof LinearAcceleratorDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof LinearAcceleratorDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LinearAcceleratorDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    defaultImageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    typeId?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof LinearAcceleratorDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {StateOfUse}
     * @memberof LinearAcceleratorDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    trackItAlias?: string | null;
    /**
     * 
     * @type {MedicalSystemBeamLimitingDeviceType}
     * @memberof LinearAcceleratorDto
     */
    beamLimitingDeviceType?: MedicalSystemBeamLimitingDeviceType;
    /**
     * 
     * @type {MedicalSystemBeamProduction}
     * @memberof LinearAcceleratorDto
     */
    beamProduction?: MedicalSystemBeamProduction;
    /**
     * 
     * @type {ElectronBeamQualitiesDto}
     * @memberof LinearAcceleratorDto
     */
    beamQualitiesElectron?: ElectronBeamQualitiesDto;
    /**
     * 
     * @type {PhotonBeamQualitiesDto}
     * @memberof LinearAcceleratorDto
     */
    beamQualitiesPhoton?: PhotonBeamQualitiesDto;
    /**
     * 
     * @type {number}
     * @memberof LinearAcceleratorDto
     */
    sourceAxisDistance: number;
    /**
     * 
     * @type {CoordinateSystem}
     * @memberof LinearAcceleratorDto
     */
    parentCoordinateSystem?: CoordinateSystem;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {NullableOneOfPropertyOfStorageLocation}
     * @memberof LinearAcceleratorDto
     */
    imageLocation?: NullableOneOfPropertyOfStorageLocation;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    externalRtSystemId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    externalFileSystemPath?: string | null;
    /**
     * 
     * @type {OneOfPropertyOfPtw100InternalArea}
     * @memberof LinearAcceleratorDto
     */
    ptw100AreaName?: OneOfPropertyOfPtw100InternalArea;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    $type?: LinearAcceleratorDtoTypeEnum;
}


/**
 * @export
 */
export const LinearAcceleratorDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsLinearAcceleratorDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.LinearAcceleratorDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type LinearAcceleratorDtoTypeEnum = typeof LinearAcceleratorDtoTypeEnum[keyof typeof LinearAcceleratorDtoTypeEnum];



/**
 * Check if a given object implements the LinearAcceleratorDto interface.
 */
export function instanceOfLinearAcceleratorDto(value?: unknown): value is LinearAcceleratorDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(LinearAcceleratorDtoTypeEnum)[0];
}

export function LinearAcceleratorDtoFromJSON(json: any): LinearAcceleratorDto {
    return LinearAcceleratorDtoFromJSONTyped(json, false);
}

export function LinearAcceleratorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinearAcceleratorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': json['editingUser'] == null ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'name': json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'typeSpecification': json['typeSpecification'] == null ? undefined : json['typeSpecification'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'defaultImageId': json['defaultImageId'] == null ? undefined : json['defaultImageId'],
        'typeId': json['typeId'] == null ? undefined : json['typeId'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'state': json['state'] == null ? undefined : StateOfUseFromJSON(json['state']),
        'trackItAlias': json['trackItAlias'] == null ? undefined : json['trackItAlias'],
        'beamLimitingDeviceType': json['beamLimitingDeviceType'] == null ? undefined : MedicalSystemBeamLimitingDeviceTypeFromJSON(json['beamLimitingDeviceType']),
        'beamProduction': json['beamProduction'] == null ? undefined : MedicalSystemBeamProductionFromJSON(json['beamProduction']),
        'beamQualitiesElectron': json['beamQualitiesElectron'] == null ? undefined : ElectronBeamQualitiesDtoFromJSON(json['beamQualitiesElectron']),
        'beamQualitiesPhoton': json['beamQualitiesPhoton'] == null ? undefined : PhotonBeamQualitiesDtoFromJSON(json['beamQualitiesPhoton']),
        'sourceAxisDistance': json['sourceAxisDistance'],
        'parentCoordinateSystem': json['parentCoordinateSystem'] == null ? undefined : CoordinateSystemFromJSON(json['parentCoordinateSystem']),
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'imageLocation': json['imageLocation'] == null ? undefined : NullableOneOfPropertyOfStorageLocationFromJSON(json['imageLocation']),
        'externalRtSystemId': json['externalRtSystemId'] == null ? undefined : json['externalRtSystemId'],
        'externalFileSystemPath': json['externalFileSystemPath'] == null ? undefined : json['externalFileSystemPath'],
        'ptw100AreaName': json['ptw100AreaName'] == null ? undefined : OneOfPropertyOfPtw100InternalAreaFromJSON(json['ptw100AreaName']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function LinearAcceleratorDtoToJSON(value?: Omit<LinearAcceleratorDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'possibleActions'|'deleterUserId'|'deletionTime'|'isDeleted'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'commentCount': value['commentCount'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'lastComment': value['lastComment'],
        'isAvailable': value['isAvailable'],
        'origin': EntityOriginToJSON(value['origin']),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'editingUser': UserCatalogDtoToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        'name': value['name'],
        'iuid': value['iuid'],
        'description': value['description'],
        'typeSpecification': value['typeSpecification'],
        'category': RtSystemCategoryToJSON(value['category']),
        'manufacturer': RtSystemManufacturerToJSON(value['manufacturer']),
        'model': value['model'],
        'subModel': value['subModel'],
        'imageId': value['imageId'],
        'isArchived': value['isArchived'],
        'defaultImageId': value['defaultImageId'],
        'typeId': value['typeId'],
        'subCategory': MedicalSystemSubCategoryToJSON(value['subCategory']),
        'state': StateOfUseToJSON(value['state']),
        'trackItAlias': value['trackItAlias'],
        'beamLimitingDeviceType': MedicalSystemBeamLimitingDeviceTypeToJSON(value['beamLimitingDeviceType']),
        'beamProduction': MedicalSystemBeamProductionToJSON(value['beamProduction']),
        'beamQualitiesElectron': ElectronBeamQualitiesDtoToJSON(value['beamQualitiesElectron']),
        'beamQualitiesPhoton': PhotonBeamQualitiesDtoToJSON(value['beamQualitiesPhoton']),
        'sourceAxisDistance': value['sourceAxisDistance'],
        'parentCoordinateSystem': CoordinateSystemToJSON(value['parentCoordinateSystem']),
        'serialNumber': value['serialNumber'],
        'imageLocation': NullableOneOfPropertyOfStorageLocationToJSON(value['imageLocation']),
        'externalRtSystemId': value['externalRtSystemId'],
        'externalFileSystemPath': value['externalFileSystemPath'],
        'ptw100AreaName': OneOfPropertyOfPtw100InternalAreaToJSON(value['ptw100AreaName']),
        '$type': value['$type'],
    });
}

